export default __webpack_public_path__ + "static/media/deloitte.png";